/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon, Text, Tooltip, VFlow } from 'bold-ui'
import { AccordionDataTable } from 'components/accordion/accordion-data-table/AccordionDataTable'
import { formatDate } from 'util/date/formatDate'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { downloadMChat } from '../../objetivo/puericultura/mchat-rf/mchat/impressao/downloadMChat'
import { MCHAT_RESULTADOS } from '../../objetivo/puericultura/mchat-rf/mchat/model-mchat'
import { MChatAcompanhamentoPuericulturaAccordionPanel } from './components/MChatAcompanhamentoPuericulturaAccordionPanel'
import { RegistroMChatAcompanhamentoPuericultura } from './model'

interface MChatAcompanhamentoPuericulturaProps {
  registrosMChat: RegistroMChatAcompanhamentoPuericultura[]
  cidadaoId: ID
  cidadaoDataNascimento: LocalDate
}

export function MChatAcompanhamentoPuericultura(props: MChatAcompanhamentoPuericulturaProps) {
  const { registrosMChat, cidadaoId, cidadaoDataNascimento } = props

  const handlePrint = (
    event: React.MouseEvent<HTMLButtonElement>,
    registroMChat: RegistroMChatAcompanhamentoPuericultura
  ) => {
    event.stopPropagation()
    downloadMChat({
      atendProfId: registroMChat.atendimentoProfissional.id,
      cidadaoId: cidadaoId,
      resultado: registroMChat.pontuacao,
      risco: registroMChat.risco,
      aplicacao: registroMChat.aplicacao,
    })
  }

  return (
    <VFlow>
      <Heading level={2}>
        M-CHAT-R/F™ <span css={styles.innerTitle}>(Checklist Modificado para Autismo em Crianças Pequenas)</span>
      </Heading>
      <AccordionDataTable<RegistroMChatAcompanhamentoPuericultura>
        noResultText='Sem registros de M-CHAT-R/F™'
        rows={registrosMChat}
        columns={[
          {
            name: 'data',
            header: 'Data',
            size: 2,
            render: (row) => <Text>{formatDate(row.dataResultado)}</Text>,
          },
          {
            name: 'resultado',
            header: 'Resultado da avaliação',
            size: 5,
            render: renderResultado,
          },
          {
            name: 'profissional',
            header: 'Profissional',
            size: 4,
            render: renderProfissional,
          },
          {
            name: 'actions',
            size: 1,
            render: (row) => (
              <HFlow justifyContent='flex-end'>
                <Tooltip text='Imprimir'>
                  <Button
                    size='small'
                    skin='ghost'
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => handlePrint(event, row)}
                  >
                    <Icon icon='printerOutline' />
                  </Button>
                </Tooltip>
              </HFlow>
            ),
          },
        ]}
        components={{
          AccordionPanel: ({ row }) => (
            <MChatAcompanhamentoPuericulturaAccordionPanel
              registroMChat={row}
              cidadaoDataNascimento={cidadaoDataNascimento}
            />
          ),
        }}
      />
    </VFlow>
  )
}

const renderResultado = (row: RegistroMChatAcompanhamentoPuericultura) => {
  const { textColor, shortTitle } = MCHAT_RESULTADOS[row.risco]
  return (
    <Text>
      <Text fontWeight='bold' style={styles.color(textColor)}>
        Risco {shortTitle} ({'ponto'.pluralizeAndConcatValue(row.pontuacao)})
      </Text>{' '}
      - M-CHAT-R™
    </Text>
  )
}

const renderProfissional = (row: RegistroMChatAcompanhamentoPuericultura) => (
  <Text>{`${formatNomeProfissional(
    row.atendimentoProfissional.lotacao.profissional
  )} - ${row.atendimentoProfissional.lotacao.cbo.nome.titleCase()}`}</Text>
)

const styles = {
  color: (textColor: string) => css`
    color: ${textColor};
  `,
  innerTitle: css`
    font-weight: normal;
  `,
}
